<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="contributi-fondo-perduto-list-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-nbMesiAmmortamentoMedioCespitiAgevolati="{ row, value }">
      {{ row.tipoId === 2 ? value : '-' }}
    </template>

    <template #column-key-investimento="{ row, value }">
      {{ row.tipoId === 2 ? value : '-' }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.contributi-fondo-perduto.edit', params: { contributoFondoPerdutoId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '@/filters/formatMoney.js';

export default {
  components: {
    AwlTable: () => import('@/libs/Table/components/AwlTable.vue'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete.vue'),
    ActionEdit: () => import('@/views/components/Actions/ActionEdit.vue'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    contributiFondoPerduto: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'tipoName', label: 'Tipo di contributo' },
        { key: 'importo', label: 'Importo' },
        { key: 'concessione', label: 'Data concessione' },
        { key: 'nbMesiAmmortamentoMedioCespitiAgevolati', label: 'Mesi ammortamento medio cespiti agevolati' },
        { key: 'investimento', label: 'Data investimento' },
      ];
    },
    tableRows () {
      return (this.contributiFondoPerduto || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
